import { render, staticRenderFns } from "./UcPropertyUnits.yaml?vue&type=template&id=ece14ce4&component"
import script from "./UcPropertyUnits.yaml?vue&type=script&lang=ts&component"
export * from "./UcPropertyUnits.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports